import React, { FC, useEffect } from "react";

export const ValidityReporter: FC<{
  isValid: boolean;
  onValidityChange?: (isValid: boolean) => void;
}> = ({ isValid, onValidityChange }) => {
  useEffect(() => {
    onValidityChange?.(isValid);
  }, [isValid, onValidityChange]);
  return null;
};
